import { isCommerceSquirrelOffer } from '../typeGuards/index.js';
/**
 * Find all offers for a vendor in the supplied commerce item
 */
export function identifyVendorOffer(item, vendor) {
    return item.offers.find((offer) => offer.vendor === vendor);
}
/**
 * Ease of use function
 *
 * @todo may be worth removing after external offers have been cleaned up
 */
export function identifyOfferStore(offer) {
    if (offer.vendor === 'Squirrel') {
        return offer.retailerName;
    }
    if (offer.retailerName !== undefined && offer.retailerName !== '') {
        return offer.retailerName;
    }
    if (offer.vendor !== 'External') {
        return offer.vendor;
    }
    return offer.metaData?.store ?? 'Unknown';
}
/**
 * Build a composite identifier that can be used to identify an offer in an offer set even if
 * the indexes have shifted.  This id is used for specifying link wrapper configs on a per-offer
 * basis, specifying offer text for buttons in multi-offer configs, and potentially other things
 */
export function buildCommerceOfferId(offer) {
    const baseId = `v#${offer.vendor}|r#${identifyOfferStore(offer) ?? 'unknown retailer'}`;
    if (isCommerceSquirrelOffer(offer)) {
        return baseId + `|a#${offer.metaData.affiliateNetwork}`;
    }
    return baseId;
}
/**
 * Build a External offer from url and a few other parameters
 *
 * This is useful as there are a few places we are doing it manually
 * in the code base.
 */
export function buildExternalOffer(url, retailerName, price = '') {
    return {
        vendor: 'External',
        saved: false,
        pullDate: Date.now(),
        metaData: {},
        url,
        price,
        retailerName,
    };
}
/**
 * Both params are optional easier pass through in components.
 */
export function identifyLinkWrappersForOffer(offer, wrappers) {
    if (offer === undefined || wrappers === undefined) {
        return undefined;
    }
    const offerId = buildCommerceOfferId(offer);
    return wrappers[offerId] ?? wrappers['default'];
}
//# sourceMappingURL=offers.js.map